import { faCrosshairs } from '@fortawesome/pro-light-svg-icons';
import { faCaretDown, faCaretUp, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { formatMetricPercentage } from '../../display/hero-metrics';
import { isNil } from 'lodash';

export type PercentDiffValues = {
  percentage: string;
  label: string;
  icon: IconDefinition;
  iconColor: string;
};

export function marginDiscountDiff(
  target: number | undefined,
  variance: number | null | undefined
): PercentDiffValues | null {
  if (isNil(target) || isNil(variance)) return null;
  const absDiff = Math.abs(variance);
  return {
    percentage: formatMetricPercentage(absDiff < 0.001 ? 0 : absDiff),
    label: absDiff < 0.001 ? 'On Target' : variance > 0 ? 'Discount' : 'Premium',
    icon: absDiff < 0.001 ? faCrosshairs : variance < 0 ? faCaretUp : faCaretDown,
    iconColor: absDiff < 0.001 ? 'text-gray-500' : variance < 0 ? 'text-green-600' : 'text-red-600'
  };
}

export function marginVarianceDiff(
  target: number | undefined,
  variance: number | null | undefined
): PercentDiffValues | null {
  if (isNil(target) || isNil(variance)) return null;
  const absDiff = Math.abs(variance);
  return {
    percentage: formatMetricPercentage(absDiff < 0.001 ? 0 : absDiff),
    label: absDiff < 0.001 ? 'On Target' : variance > 0 ? 'More' : 'Less',
    icon: absDiff < 0.001 ? faCrosshairs : variance > 0 ? faCaretUp : faCaretDown,
    iconColor: absDiff < 0.001 ? 'text-gray-500' : variance > 0 ? 'text-green-600' : 'text-red-600'
  };
}

export function unitCostVarianceDiff(
  target: number | undefined,
  variance: number | null | undefined
): PercentDiffValues | null {
  if (isNil(target) || isNil(variance)) return null;
  const absDiff = Math.abs(variance);
  return {
    percentage: formatMetricPercentage(absDiff < 0.001 ? 0 : absDiff),
    label: absDiff < 0.001 ? 'On Target' : variance > 0 ? 'More' : 'Less',
    icon: absDiff < 0.001 ? faCrosshairs : variance > 0 ? faCaretUp : faCaretDown,
    iconColor: absDiff < 0.001 ? 'text-gray-500' : variance < 0 ? 'text-green-600' : 'text-red-600'
  };
}
